import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
import { Workbook } from "exceljs";
/**
 *
 * @param {any[]} sellsByHour
 * @returns {Workbook}
 */
export const exportExcel = async (sellsByHour, selectedStore, selectedYear) => {
  const json = excelHelper.jsonToJson(
    [sellsByHour],
    [
      {
        name: "VENTAS MES - AÑO",
        props: [
          {
            inValue: "month",
            outValue: "MES",
          },
          {
            inValue: "name",
            outValue: "NOMBRE",
          },
          {
            inValue: "total",
            outValue: "VENTAS TOTALES",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore, selectedYear);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore, selectedYear) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-general-ventas-por-mes_" +
        selectedYear.value +
        ".csv"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-ventas-por-mes_" +
        selectedYear.value +
        "_" +
        storeName.toLowerCase() +
        ".csv";
};



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardSellsByMonth/excel.js